export function EmptyState({ icon: Icon, title, description, action }) {
  return (
    <div
      className="flex flex-col items-center justify-center gap-3 rounded-2xl border border-dashed border-border bg-secondary/40 px-6 py-16 text-center"
      data-testid="empty-state"
    >
      {Icon ? <Icon className="h-10 w-10 text-sage-light" strokeWidth={1.4} /> : null}
      <h3 className="font-display text-xl text-foreground">{title}</h3>
      {description ? (
        <p className="max-w-md text-sm text-muted-foreground">{description}</p>
      ) : null}
      {action ? <div className="mt-2">{action}</div> : null}
    </div>
  );
}
